import Trix from 'trix'
import naja from 'naja'
import imageCompression from 'browser-image-compression'
import 'emoji-picker-element'
import {createPopper} from "@popperjs/core";
import {cs} from './_emoji-picker'
import {Base64} from "js-base64";

document.querySelectorAll('._trix-input').forEach((trix) => {
	const checkNestingLevel = () => {
		const maxNestingLevel = trix.dataset.maxNestingLevel
		const currentNestingLevel = trix.editor.composition.getBlock().getNestingLevel() - 1

		return maxNestingLevel === null || currentNestingLevel < maxNestingLevel
	}

	const toggleToolbarButtons = () => {
		const toolbar = trix.editorController.toolbarController.element
		const decreaseNestingButton = toolbar.querySelector('button[data-trix-action="x-decreaseNestingLevel"]')
		const increaseNestingButton = toolbar.querySelector('button[data-trix-action="x-increaseNestingLevel"]')
		const headingButton = toolbar.querySelector('button[data-trix-attribute="heading"]')
		const heading1Button = toolbar.querySelector('button[data-trix-attribute="heading1"]')
		const heading2Button = toolbar.querySelector('button[data-trix-attribute="heading2"]')
		const heading3Button = toolbar.querySelector('button[data-trix-attribute="heading3"]')
		const quoteButton = toolbar.querySelector('button[data-trix-attribute="quote"]')
		const codeButton = toolbar.querySelector('button[data-trix-action="x-code"]')

		if (trix.editorController.currentAttributes?.presentation !== undefined) {
			// Rezim editace obrazku
			if (headingButton !== null) {
				headingButton.setAttribute('disabled', '')
			}
			if (heading1Button !== null) {
				heading1Button.setAttribute('disabled', '')
			}
			if (heading2Button !== null) {
				heading2Button.setAttribute('disabled', '')
			}
			if (heading3Button !== null) {
				heading3Button.setAttribute('disabled', '')
			}
			quoteButton.setAttribute('disabled', '')
			codeButton.setAttribute('disabled', '')
		}

		if (decreaseNestingButton !== null && increaseNestingButton !== null) {
			// Je zapnuta zmena zanoreni, takze je treba kontrolovat aktivaci tlacitek
			if (trix.editor.canDecreaseNestingLevel()) {
				decreaseNestingButton.removeAttribute('disabled')
			} else {
				decreaseNestingButton.setAttribute('disabled', '')
			}

			if (trix.editor.canIncreaseNestingLevel() && checkNestingLevel()) {
				increaseNestingButton.removeAttribute('disabled')
			} else {
				increaseNestingButton.setAttribute('disabled', '')
			}
		}
	}

	trix.addEventListener('trix-before-initialize', () => {
		Trix.config.blockAttributes.default = {
			parse: false,
			tagName: 'p',
		}
		Trix.config.blockAttributes.heading = {
			breakOnReturn: true,
			group: false,
			tagName: 'h1',
			terminal: true
		}
		Trix.config.blockAttributes.heading1 = {
			breakOnReturn: true,
			group: false,
			tagName: 'h2',
			terminal: true
		}
		Trix.config.blockAttributes.heading2 = {
			breakOnReturn: true,
			group: false,
			tagName: 'h3',
			terminal: true
		}
		Trix.config.blockAttributes.heading3 = {
			breakOnReturn: true,
			group: false,
			tagName: 'h4',
			terminal: true
		}
		Trix.config.blockAttributes.pre = Trix.config.blockAttributes.code
		Trix.config.textAttributes.code = {
			inheritable: true,
			tagName: 'code'
		}

		delete Trix.config.blockAttributes.code

		Trix.config.lang.captionPlaceholder = trix.dataset.captionTranslation

		Trix.config.attachments.preview.caption.name = false
		Trix.config.attachments.preview.caption.size = false

		// Omezeni pro maximalni uroven zanoreni
		// Prevzato z knihovny Trix (od 37signals, LLC., licence: MIT), upraveno
		Trix.controllers.Level2InputController.keys.Tab = function() {
			if (this.responder !== null && this.responder.canIncreaseNestingLevel()) {
				this.event.preventDefault()

				const maxNestingLevel = this.responder.delegate.editorElement.dataset.maxNestingLevel
				const currentNestingLevel = this.responder.delegate.composition.getBlock().getNestingLevel() - 1

				if (maxNestingLevel === null || currentNestingLevel < maxNestingLevel) {
					this.responder.increaseNestingLevel()
				}

				return this.render()
			}
		}
	})

	// Pridani podpory pro SVG obrazky
	Trix.Attachment.previewablePattern = /^image(\/(gif|png|jpe?g|svg)|$)/

	trix.addEventListener('trix-initialize', () => {
		const toolbar = trix.editorController.toolbarController.element
		const toolbarContent = document.querySelector(`._trix-toolbar-content[data-for="${trix.getAttribute('input')}"]`)
		const content = document.querySelector(`._trix-content[data-for="${trix.getAttribute('input')}"]`)

		toolbar.innerHTML = toolbarContent.innerHTML

		if (content !== null) {
			// Nacitani obsahu z HTML tento Trix nepotrebuje
			trix.value = content.innerHTML
		}

		// Oprava chovani, kdyz je vybrany obrazek (jinak se "nic nestane", dokud uzivatel neklikne vedle)
		toolbar.querySelectorAll('button[data-trix-update="true"]').forEach((button) => {
			button.addEventListener('click', () => {
				if (trix.editorController.currentAttributes?.presentation !== undefined) {
					trix.editor.moveCursorInDirection("forward")
				}
			})
		})

		// Emoji picker
		const emojiPicker = document.querySelector('[data-trix-emoji-picker]')
		const emojiButton = toolbar.querySelector('[data-trix-action="x-emoji"]')

		emojiPicker.container = emojiPicker.parentElement
		emojiPicker.backdrop = document.querySelector('[data-trix-emoji-backdrop]')

		if (trix.dataset.locale === 'cs') {
			emojiPicker.i18n = cs
		}

		document.querySelectorAll('link[rel="stylesheet"]').forEach(stylesheetLink => {
			emojiPicker.shadowRoot.appendChild(stylesheetLink.cloneNode(true))
		})

		emojiPicker.addEventListener('emoji-click', (event) => {
			const emoji = event.detail.unicode

			trix.editor.insertString(emoji)
			emojiPicker.hide()
		})
		emojiPicker.show = () => {
			emojiPicker.container.classList.remove('d-none')
			emojiPicker.popper = createPopper(emojiButton, emojiPicker.container, {'placement': 'bottom-end'})

			emojiPicker.backdrop.classList.add('show')
			emojiPicker.backdrop.addEventListener('click', () => emojiPicker.hide())
		}
		emojiPicker.hide = () => {
			emojiPicker.backdrop.classList.remove('show')
			emojiPicker.container.classList.add('d-none')
			emojiPicker.popper.destroy()
		}

		trix.emojiPicker = emojiPicker
	})

	trix.addEventListener('trix-change', () => {
		toggleToolbarButtons()
		Nette.validateForm(trix.form)
	})
	trix.addEventListener('trix-selection-change', () => toggleToolbarButtons())

	trix.addEventListener('trix-action-invoke', (event) => {
		if (event.actionName === 'x-code') {
			const selectedRange = trix.editor.getSelectedRange()
			const selectedString = trix.editor.getDocument().getStringAtRange(selectedRange)

			trix.editor.activateAttribute('code')

			if (selectedString.includes('\n')) {
				trix.editor.activateAttribute('pre')
			}
		} else if (event.actionName === 'x-increaseNestingLevel') {
			if (!checkNestingLevel()) {
				toggleToolbarButtons()

				return
			}

			trix.editor.increaseNestingLevel()

			// Oprava chovani, kdyz je vybrany obrazek (jinak se "nic nestane", dokud uzivatel neklikne vedle)
			if (trix.editorController.currentAttributes?.presentation !== undefined) {
				trix.editor.moveCursorInDirection("forward")
			}
		} else if (event.actionName === 'x-decreaseNestingLevel') {
			trix.editor.decreaseNestingLevel()

			// Oprava chovani, kdyz je vybrany obrazek (jinak se "nic nestane", dokud uzivatel neklikne vedle)
			if (trix.editorController.currentAttributes?.presentation !== undefined) {
				trix.editor.moveCursorInDirection("forward")
			}
		} else if (event.actionName === 'x-emoji') {
			trix.emojiPicker.show()
		}
	})

	trix.addEventListener('trix-attachment-add', (event) => {
		// Jiz nahrane obrazky (pri vraceni se v historii apod.)
		if (event.attachment.file === undefined || event.attachment.file === null) {
			event.preventDefault()
			return
		}

		// Vlozeni obrazku jako inline verzi zakodovanou pomoci base64
		if (trix.dataset.enableBase64Images === 'true') {
			const file = event.attachment.file
			const fileReader = new FileReader()
			const maxSize = parseFloat(trix.dataset.maxCompressedImageSize)
			const longestDimension = parseInt(trix.dataset.longestCompressedImageDimension)

			// SVG soubory se zpracovavaji zvlast, protoze se nepracuje s pixely, ale se zdrojovym kodem
			if (/\.svg$/.test(file.name)) {
				fileReader.addEventListener('loadend', () => {
					const svgCode = fileReader.result

					const base64encoded = Base64.encode(svgCode)
					const asDataUrl = `data:image/svg+xml;base64,${base64encoded}`

					event.attachment.setUploadProgress(100)
					event.attachment.setAttributes({
						url: asDataUrl,
						previewURL: asDataUrl
					})
				})

				fileReader.readAsText(file)

				return
			}

			fileReader.addEventListener('loadend', () => {
				event.attachment.setUploadProgress(100)
				event.attachment.setAttributes({
					url: fileReader.result
				})
			})

			imageCompression(file, {
				maxSizeMB: maxSize !== -1.0 ? maxSize : Number.POSITIVE_INFINITY,
				maxWidthOrHeight: longestDimension !== -1 ? longestDimension : undefined,
				useWebWorker: true,
				onProgress: (progress) => {
					// 0-100 --> 0-90 (jeste se to bude konvertovat na base64)
					event.attachment.setUploadProgress((progress / 100) * 90)
				}
			}).then((compressedFile) => {
				fileReader.readAsDataURL(compressedFile)
			}).catch(() => {
				event.attachment.remove()
				event.preventDefault()
			})

			return
		}

		const fileInput = document.querySelector(`._trix-upload-file[data-id="${trix.getAttribute('input')}"]`)
		const form = fileInput.closest('form')
		const formData = new FormData(form)

		formData.append('file', event.attachment.file)

		naja.makeRequest(form.method, location.pathname, formData, {unique: 'trix-upload-file'})
			.then((payload) => {
				if (payload.status === 'success') {
					event.attachment.setUploadProgress(100)
					event.attachment.setAttributes({
						url: payload.imageUrl
					})
				} else {
					event.attachment.remove()
					event.preventDefault()
				}
			})
			.catch(() => {
				event.attachment.remove()
				event.preventDefault()
			})
	})

	trix.addEventListener('trix-attachment-remove', (event) => {
		// Jeste nenahrany soubor
		if (event.attachment.file === null || event.attachment.file === undefined) {
			return
		}

		// Obrazek kodovany do base64 se odnikud neodstranuje
		if (trix.dataset.enableBase64Images === 'true') {
			return
		}

		// noinspection JSIgnoredPromiseFromCall Neni potreba se tim dale zabyvat
		// (pokud selze, tak pri nejhorsim zustane soubor)
		naja.makeRequest('GET', location.pathname + '?do=trix-removeFile', {
			'trix-imageName': event.attachment.file.name
		}, {unique: 'trix-remove-file'})
	})
})
